module.exports = __webpack_public_path__ + "static/media/user1.44768871.png";